import { Button as MUIButton, type ButtonProps as MUIButtonProps } from '@mui/material'
import { forwardRef } from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from '@/helpers/Link'

//	///////////////////////
//	MARK: TYPES
export type TButtonLinkProps = MUIButtonProps & LinkProps

//	///////////////////////
//	MARK: EXPORTS
export const ButtonLink = forwardRef<HTMLAnchorElement, TButtonLinkProps>((props, ref) => (
  <MUIButton component={Link} ref={ref} {...props} />
))
